export default {
    geoAddress: "Miramichi and surrounding area, NB Canada",
    phoneNumber: "+1 (506) 867 5309",
    emailAddress: "graciesrescue@outlook.com",
    copyRight: "Gracie’s Cat Rescue © 2025. All Rights Reserved."
}
